module.exports = __webpack_public_path__ + "static/media/vial.9d0692ca.svg";